import React from 'react'
import Thirdproduct4details from '../Advertisement/Thirdproduct4details'

function Supersalearea3() {
    return (
        <div>
            <Thirdproduct4details/>
        </div>
    )
}

export default Supersalearea3
